export default __webpack_public_path__ + "static/media/delivery.d0626670.svg";